import { isMobile } from "./appUtils";
import { COLORS } from './colors';

export const debounce = (func: any, delay: number) => {
  let timeoutId: NodeJS.Timeout | null = null;

  const debouncedFunction = (...args: any) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func.apply(null, args);
      timeoutId = null;
    }, delay);
  };

  debouncedFunction.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  };

  return debouncedFunction;
};

export const throttle = (func: any, limit: number) => {
  let lastFunc: any;
  let lastRan: any;

  return function (...args: any) {
    if (!lastRan) {
      // @ts-ignore
      func.apply(this, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(() => {
        if (Date.now() - lastRan >= limit) {
          // @ts-ignore
          func.apply(this, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};

// Function to modify the style of Header, Tabs and Watch Container
export const modifyStyles = (
  headerEl: HTMLElement | null,
  tabsEl: HTMLElement | null,
  watchContainerEl: HTMLElement | null,
  tabContainerDivEl: HTMLElement | null,
  colorFont: string,
  defaultColorFont: string
) => {
  if (!isMobile()) {
    modifyHeader(headerEl);
    if (tabContainerDivEl) tabContainerDivEl.style.backgroundColor = "transparent"
    if (tabsEl) {
      tabsEl.classList.add('watch-page');
    }
    if (watchContainerEl) {
      watchContainerEl.style.position = "relative";
      watchContainerEl.style.top = "-120px";
    }
  }
};

// Function to reset the style of Header, Tabs and Watch Container back to default
export const resetDefaultStyles = (
  headerEl: HTMLElement | null,
  tabsEl: HTMLElement | null,
  watchContainerEl: HTMLElement | null,
  tabContainerDivEl: HTMLElement | null,
  colorFont: string,
  defaultColorFont: string
) => {

  if (!isMobile()) {
    // restoreDefaultHeader(headerEl);
    if (tabContainerDivEl) tabContainerDivEl.style.backgroundColor = colorFont;
    if (tabsEl) {
      tabsEl.style.backgroundColor = '';
      tabsEl.style.color = '';
      tabsEl.classList.remove('watch-page');
    }
    if (watchContainerEl) {
      watchContainerEl.style.position = "";
      watchContainerEl.style.top = "";
    }
  }
};

export const restoreDefaultHeader = (
  headerEl: HTMLElement | HTMLDivElement | null,
  colorFont: string = COLORS.OFF_WHITE,
  defaultColorFont: string = COLORS.TEXT_DARK
) => {
  if (headerEl) {
    headerEl.style.backgroundColor = colorFont;
    (document.querySelector(".search") as HTMLElement).style.color =
      defaultColorFont;
    (
      document.querySelector(
        ".globe-icon-wrapper > svg > path"
      ) as HTMLElement
    ).style.fill = defaultColorFont;
    (
      document.querySelector(".language-selector") as HTMLElement
    ).style.color = defaultColorFont;
    (document.querySelector(".language-text") as HTMLElement).style.color =
      defaultColorFont;
    (document.querySelector(".contact") as HTMLElement).style.color =
      defaultColorFont;

    (
      document.querySelector(".search > svg > path") as HTMLElement
    ).style.fill = defaultColorFont;
    const contactSvgEl = document.querySelector<SVGElement>(".contact-icon");
    if (contactSvgEl) {
      const paths = contactSvgEl.querySelectorAll<SVGPathElement>("path");
      paths.forEach((path) => {
        path.style.stroke = defaultColorFont;
      });
    }
  }
}

export const modifyHeader = (
  headerEl: HTMLElement | HTMLDivElement | null,
  colorFont: string = COLORS.OFF_WHITE,
  defaultColorFont: string = COLORS.TEXT_DARK
) => {
  if (headerEl) {
    headerEl.style.backgroundColor = "transparent";
    (
      document.querySelector(
        ".globe-icon-wrapper > svg > path"
      ) as HTMLElement
    ).style.fill = colorFont;
    (document.querySelector(".search") as HTMLElement).style.color =
      colorFont;
    (
      document.querySelector(".language-selector") as HTMLElement
    ).style.color = colorFont;
    (document.querySelector(".language-text") as HTMLElement).style.color =
      colorFont;
    (document.querySelector(".contact") as HTMLElement).style.color =
      colorFont;

    (
      document.querySelector(".search > svg > path") as HTMLElement
    ).style.fill = colorFont;
    const contactSvgEl = document.querySelector<SVGElement>(".contact-icon");
    if (contactSvgEl) {
      const paths = contactSvgEl.querySelectorAll<SVGPathElement>("path");
      paths.forEach((path) => {
        path.style.stroke = colorFont;
      });
    }
  }
}
